import { ShoppingCart, FileText, ClipboardList, Truck } from "lucide-react";
import "./TopMetrics.css";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Spinner } from "react-bootstrap";
import { fetchTopMetrics } from "slices/Dashboard/Top_Metrics/thunk";
import { WarehouseOption } from "./DashboardFilters";

interface TopMetricsProps {
  dateFrom?: Date;
  dateTo?: Date;
  warehouse?: WarehouseOption[];
}

interface MetricConfig {
  icon: typeof ShoppingCart;
  colorTheme: "green" | "blue" | "purple" | "teal";
  dataKey: "totalSalesOrders" | "totalQuotations" | "totalEnquiries" | "totalDispatch";
}

const metricsConfig: MetricConfig[] = [
  {
    icon: ShoppingCart,
    colorTheme: "green",
    dataKey: "totalSalesOrders",
  },
  {
    icon: FileText,
    colorTheme: "blue",
    dataKey: "totalQuotations",
  },
  {
    icon: ClipboardList,
    colorTheme: "purple",
    dataKey: "totalEnquiries",
  },
  {
    icon: Truck,
    colorTheme: "teal",
    dataKey: "totalDispatch",
  },
];

export function TopMetrics({
  dateFrom,
  dateTo,
  warehouse = [],
}: TopMetricsProps) {
  const dispatch = useDispatch<any>();
  const { data: metricsData, loading } = useSelector(
    (state: any) => state.TopMetricsReducer
  );

  useEffect(() => {
    dispatch(fetchTopMetrics({ dateFrom, dateTo, warehouse })).catch(
      (error: any) => {
        console.error("Error fetching top metrics data:", error);
        toast.error("Failed to load dashboard metrics");
      }
    );
  }, [dispatch, dateFrom, dateTo, warehouse]);

  return (
    <div className="top-metrics-container">
      {/* Row 1 - Operations Overview */}
      <div className="metrics-row">
        {metricsConfig.map((metric) => {
          const Icon = metric.icon;
          const metricData = metricsData?.[metric.dataKey];

          return (
            <div
              key={metric.dataKey}
              className={`metric-card metric-card-${metric.colorTheme} position-relative overflow-hidden ${
                loading ? "metric-card-loading" : ""
              }`}
            >
              <div className="metric-corner-decoration"></div>
              <div className="metric-header">
                <div className="metric-header-content">
                  <div className={`icon-container icon-container-${metric.colorTheme}`}>
                    <Icon className={`icon text-${metric.colorTheme}`} />
                  </div>
                  <span className="metric-label">
                    {metricData?.label}
                  </span>
                </div>
              </div>
              {loading ? (
                <div
                  className="d-flex align-items-center justify-content-center metric-value"
                  style={{ minHeight: "2.5rem" }}
                >
                  <Spinner animation="border" variant="primary" size="sm" />
                </div>
              ) : (
                <p className="metric-value">
                  {metricData?.value}
                </p>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
